export function getVoterId() {
  let id = localStorage.getItem("coccon_voter_id");
  if (!id) {
    id = window.crypto?.randomUUID?.() || `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("coccon_voter_id", id);
  }
  return id;
}
